module.exports = __webpack_public_path__ + "img/f43ae49.jpg";